import { useQuery } from '@tanstack/react-query'
import { registrosApi } from '../api/registros.api'

function isEventToday(fechaEvento: string | null | undefined): boolean {
  if (!fechaEvento) return false
  const today = new Date().toISOString().slice(0, 10)
  return fechaEvento.slice(0, 10) === today
}

export function useAsistenciasData(configId: number) {
  return useQuery({
    queryKey: ['asistencias-dashboard', configId],
    queryFn: () => registrosApi.getDashboardAsistencias(configId),
    refetchInterval: (query) => {
      const data = query.state.data
      return isEventToday(data?.estadisticas.fecha_evento) ? 300_000 : false
    },
  })
}
